<template>
  <ul class="answers" :class="{ 'multiple' : multiselect }">
    <li
      v-for="(answer, index) in answers"
      :class="[{ 'quiz-correct-answer' : answer.correct }, { 'opened' : openedAnswer(index) }]"
      :key="`content-${index}`">
      <i class="answer-icon"></i>
      <input v-if="multiselect" type="checkbox" name="quiz" :id="inputId + index" @change='clickAnswer(index)'>
      <input v-else type="radio" name="quiz" :id="inputId + index" @change='clickAnswer(index)'>
      <label
        :for="inputId + index">
        <div v-html="answer.content"></div>
      </label>
      <transition name="slidedown">
        <div
          v-show="answer.rationale && openedAnswer(index)"
          :id="`rationale-answer-${index}`"
          class="rationale-answer">
          <span></span>
          <p v-html="answer.rationale"></p>
        </div>
      </transition>
    </li>
  </ul>
</template>
<script>
import { uniqueId } from 'lodash'
export default {
  props: {
    answers: {
      type: Array,
      required: true
    },
    multiselect: {
      type: Boolean
    }
  },

  data() {
    return {
      indexArray: [...Array(this.answers.length).fill()],
    }
  },

  computed: {
    inputId() {
      return "input_" + uniqueId()
    }
  },

  methods: {
    openedAnswer(index) {
      return index == this.indexArray.find((e) => e == index)
    },
    clickAnswer(index) {
      this.indexArray.splice(index, 1, index)
      this.$emit('answerClicked', true)
    }
  }
}
</script>
